<template>
  <div class="horizontal-states-bar" v-if="available">
    <span v-if="superCompleted" class="super-completed" :style="{width:superCompleted/sum*100+'%'}"></span>
    <span v-if="completed" class="completed" :style="{width:completed/sum*100+'%'}"></span>
    <span v-if="partially" class="partially" :style="{width:partially/sum*100+'%'}"></span>
    <span v-if="skipped" class="skipped" :style="{width:skipped/sum*100+'%'}"></span>
  </div>
</template>

<script>
export default {
  name: 'HorizontalStatesBar',
  props: {
    superCompleted: {
      type: Number,
      default: 0
    },
    completed: {
      type: Number,
      default: 0
    },
    partially: {
      type: Number,
      default: 0
    },
    skipped: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      displayNumber:0,
      interval:false
    }
  },
  computed: {
    available() {
      return !!(this.superCompleted || this.completed || this.partially || this.skipped)
    },
    sum() {
      return this.superCompleted + this.completed + this.partially + this.skipped
    }
  }
}
</script>
<style lang="scss" scoped>
.horizontal-states-bar {
  display: flex;
  justify-content: stretch;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 4px;
  span {
    display: block;
    height: 8px;
    position: relative;
    transition-duration: 600ms;
    border-radius: 4px 0 0 4px;
    &::after {
      content: '';
      width: 8px;
      height: 8px;
      display: block;
      position: absolute;
      right: -8px;
    }
    &.super-completed {
      background: #945EFF;
      z-index: 0;
      &::after {
        background: #945EFF;
      }
    }
    &.completed {
      background: #00A0E0;
      z-index: 1;
      &::after {
        background: #00A0E0;
      }
    }
    &.partially {
      background: #BDD0FF;
      z-index: 2;
      &::after {
        background: #BDD0FF;
      }
    }
    &.skipped {
      background: #E74F48;
      z-index: 3;
    }
    &:last-child {
      border-radius: 4px;
    }
  }
}
</style>